(function () {
  'use strict';

  const popup = document.querySelector('[data-l-newsletter-popup]');
  const bar = document.querySelector('[data-l-newsletter-bar]');
  if (!popup) return;

  const root = popup.closest('.l-newsletter-root');
  const delay = parseInt(root?.dataset?.delay || '3', 10) * 1000;
  const reappearDays = parseInt(root?.dataset?.reappearDays || '7', 10);
  const STORAGE_KEY = 'limenda_newsletter_dismissed';
  const SUBSCRIBED_KEY = 'limenda_newsletter_subscribed';

  const openPopup = () => {
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    bar?.classList.remove('is-visible');
    document.body.classList.add('l-newsletter-open');
  };

  const closePopup = (showBar) => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('l-newsletter-open');
    if (showBar) {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
      bar?.classList.add('is-visible');
    }
  };

  const hideAll = () => {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    bar?.classList.remove('is-visible');
    document.body.classList.remove('l-newsletter-open');
    localStorage.setItem(SUBSCRIBED_KEY, '1');
  };

  if (localStorage.getItem(SUBSCRIBED_KEY)) return;

  const dismissed = localStorage.getItem(STORAGE_KEY);
  if (dismissed) {
    const elapsed = (Date.now() - parseInt(dismissed, 10)) / 86400000;
    if (elapsed < reappearDays) {
      bar?.classList.add('is-visible');
    } else {
      setTimeout(openPopup, delay);
    }
  } else {
    setTimeout(openPopup, delay);
  }

  popup.querySelectorAll('[data-l-newsletter-close]').forEach((el) => {
    el.addEventListener('click', () => closePopup(true));
  });

  bar?.addEventListener('click', (e) => {
    if (e.target.closest('[data-l-newsletter-bar-close]')) return;
    openPopup();
  });

  bar?.querySelector('[data-l-newsletter-bar-close]')?.addEventListener('click', (e) => {
    e.stopPropagation();
    bar.classList.remove('is-visible');
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  });

  if (popup.querySelector('[data-l-newsletter-success]')) {
    hideAll();
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && popup.classList.contains('is-open')) {
      closePopup(true);
    }
  });
})();
